module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_6005.5d15280e.png";